import classNames from 'classnames';
import { useTranslation } from 'lib/translation';
import { useRouter } from 'next/router';
import { Icon } from 'src/types';
import { api } from 'utils/client';

import { ArrowCircleUpRight, Home02, Lightbulb05, LogOut02, MessageQuestionSquare, Settings01 } from '../misc/icons';
import IconButton from './IconButton';

type NavItemProps = {
  icon: Icon;
  label: string;
  href: string;
};

const navItems: NavItemProps[] = [
  {
    icon: Home02,
    label: 'page.dashboard',
    href: '/dashboard',
  },
  {
    icon: Lightbulb05,
    label: 'page.quizzes',
    href: '/quizzes',
  },
  {
    icon: MessageQuestionSquare,
    label: 'page.questions',
    href: '/questions',
  },
  {
    icon: ArrowCircleUpRight,
    label: 'page.games',
    href: '/games',
  },
];

const AppBar = () => {
  const { translate } = useTranslation();
  const router = useRouter();
  const logout = api.auth.logout.useMutation({
    onSuccess: () => {
      router.push('/');
    },
  });

  const handleLogout = () => {
    logout.mutate();
  };

  return (
    <div
      className={classNames(
        'fixed left-0 right-0 bottom-0 z-30 border-t border-gray-200 bg-white px-4 py-3',
        'md:relative md:top-0 md:right-auto md:bottom-0 md:mt-6 md:w-[5.5rem] md:border-t-0 md:border-r md:px-6 md:pb-6 md:pt-6'
      )}
    >
      <div className="flex justify-center gap-4 md:sticky md:top-6 md:flex-col md:justify-between md:gap-6">
        <nav className="flex items-center justify-center gap-4 md:flex-col md:gap-6">
          {navItems.map((item) => (
            <IconButton
              as="link"
              color="gray"
              key={item.href}
              href={item.href}
              icon={item.icon}
              className={classNames({
                'text-primary-500': router.pathname === item.href,
              })}
            >
              {translate(item.label)}
            </IconButton>
          ))}
        </nav>
        <nav className="flex items-center justify-center gap-4 md:flex-col md:gap-6">
          <IconButton
            as="link"
            color="gray"
            href="/settings"
            icon={Settings01}
            className={classNames({
              'text-primary-500': router.pathname === '/settings',
            })}
          >
            {translate('page.settings')}
          </IconButton>
          <IconButton color="gray" onClick={handleLogout} icon={LogOut02}>
            {translate('form.signout')}
          </IconButton>
        </nav>
      </div>
    </div>
  );
};

export default AppBar;
